import RegisterJira from "./RegisterJira";

export default RegisterJira;
